import { render, staticRenderFns } from "./mobile-staff-selector.vue?vue&type=template&id=53874838&scoped=true&"
import script from "./mobile-staff-selector.vue?vue&type=script&lang=ts&"
export * from "./mobile-staff-selector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53874838",
  null
  
)

export default component.exports